module.exports = __webpack_public_path__ + "static/img/Slip.d3713f1e.svg";